// Header And Announcnment Bar Top Height Script

// Header Video Script
$(document).ready(function () {
  $(
    ".fq_nav_mainflexrightcolbotdivrightplay_btn, .fq_nav_mainflexrightcolbotdivrightvideo"
  ).on("click", function (cust_faq_vi_e) {
    cust_faq_vi_e.stopPropagation();

    const cust_faq_vi_wrapper = $(this).closest(".fq_video_wrapper");
    const cust_faq_vi_video = cust_faq_vi_wrapper.find("video").get(0);

    if (cust_faq_vi_video.paused) {
      cust_faq_vi_video.play();
      cust_faq_vi_wrapper.addClass("playing");
    } else {
      cust_faq_vi_video.pause();
      cust_faq_vi_video.currentTime = 0;
      cust_faq_vi_video.load(); // Reload to show poster again
      cust_faq_vi_wrapper.removeClass("playing");
    }
  });
});

// Header Faqs Script

$(document).ready(function () {
  $(".fq_nav_mainflexrightbotdivleftfaqsflexdiv").click(function () {
    var $desc = $(this).next(".fq_nav_mainflexrightbotdivleftfaqsflexdesc");

    // Close all except the current
    $(".fq_nav_mainflexrightbotdivleftfaqsflexdesc").not($desc).slideUp();
    $(".fq_nav_mainflexrightbotdivleftfaqsflexdiv")
      .not(this)
      .removeClass("active");

    $desc.slideToggle();
    $(this).toggleClass("active");
  });
});

// Header Mobile and Desktop Mega Menu Script
$(document).ready(function () {
  const isMobile = () => window.innerWidth < 992;

  // ===== Search Icon Click =====
  $(".cust-search-iconmain").on("click", function () {
    const new_nhph_isSearchVisible = $(".hedsearch_navmainn").is(":visible");

    // Close mobile menu
    $(".nhph_navs_linksmobile").slideUp();
    $(".mobile_menu_bar i").removeClass("fa-xmark").addClass("fa-bars");
    $(".mobile_menu_bar").removeClass("active");
    if (isMobile()) {
      $(".hedcustom-overlay").fadeOut();
    }

    // Close nav panels
    $(".walmart_navmainn").slideUp(200, function () {
      new_nhph_checkHeaderState();
    });
    $(".walmart_nav_linkk").removeClass("active");
    $(".get_s_navflexmainsublim").removeClass("active");

    if (!new_nhph_isSearchVisible) {
      $("header").addClass("active");
      $("body").css("overflow-y", "hidden");
      $(".hedsearch_navmainn")
        .stop(true, true)
        .slideDown(500, function () {
          $(".hedcustom-overlay").fadeIn();
        })
        .addClass("active");
      $(".cust-search-iconmain").addClass("active");
      $(".nhph_headertopdatamain").slideDown(300);
    } else {
      $(".hedsearch_navmainn").slideUp(200, function () {
        $(this).removeClass("active");
        new_nhph_checkHeaderState();
      });
      $(".cust-search-iconmain").removeClass("active");
      $(".hedcustom-overlay").fadeOut();
      $(".nhph_headertopdatamain").slideUp(300);
    }
  });

  // ===== Navigation Click =====
  $(".walmart_nav_linkk").on("click", function () {
    const new_nhph_index = $(".walmart_nav_linkk").index(this);
    const new_nhph_targetPanel = $(".walmart_navmainn").eq(new_nhph_index);
    const new_nhph_isVisible = new_nhph_targetPanel.is(":visible");

    $(".walmart_navmainn").slideUp(200, function () {
      new_nhph_checkHeaderState();
    });
    $(".walmart_nav_linkk").removeClass("active");
    $(".hedsearch_navmainn").slideUp(200, function () {
      $(this).removeClass("active");
      new_nhph_checkHeaderState();
    });
    $(".cust-search-iconmain").removeClass("active");
    $(".get_s_navflexmainsublim").removeClass("active");

    if (!new_nhph_isVisible) {
      $("header").addClass("active");
      $("body").css("overflow-y", "hidden");

      new_nhph_targetPanel.slideDown(500, function () {
        const new_nhph_slider = $(this).find('.megamenu_slider');
        if (new_nhph_slider.length) {
          const slideCount = new_nhph_slider.children('.slick-slide').length;
          const slidesToShowSetting = slideCount > 1 ? 1.3 : 1;

          if (!new_nhph_slider.hasClass('slick-initialized')) {
            new_nhph_slider.slick({
              slidesToShow: slidesToShowSetting,
              slidesToScroll: 1,
              dots: true,
              arrows: false,
              infinite: false,
              speed: 300,
              autoplay: false,
              prevArrow: '<span class="custom-prevv"><i class="fa fa-arrow-left"></i></span>',
              nextArrow: '<span class="custom-nextt"><i class="fa fa-arrow-right"></i></span>',
              responsive: [
                {
                  breakpoint: 1100,
                  settings: {
                    slidesToShow: slidesToShowSetting,
                  }
                }
              ]
            });
          } else {
            new_nhph_slider.slick('slickSetOption', 'slidesToShow', slidesToShowSetting, true);
            new_nhph_slider.slick('setPosition');
          }
        }
      });

      $(this).addClass("active");
      $(".nhph_headertopdatamain").slideDown(300);
      $(this).closest(".get_s_navflexmainsublim").addClass("active");

      if (!isMobile()) {
        $(".hedcustom-overlay").fadeIn();
      }
    }
  });

  // ===== Mobile Menu Toggle =====
  $(".mobile_menu_bar").on("click", function () {
    $(".hedsearch_navmainn").slideUp(200, function () {
      $(this).removeClass("active");
      new_nhph_checkHeaderState();
    });
    $(".cust-search-iconmain").removeClass("active");
    $(".nhph_headertopdatamain").slideUp(300);

    const new_nhph_isOpen = $(".nhph_navs_linksmobile").is(":visible");
    if (!new_nhph_isOpen) {
      $("header").addClass("active");
      $("body").css("overflow-y", "hidden");

      const new_nhph_firstNavLink = $(".get_s_navflexmainsublim").first().find(".walmart_nav_linkk").first();
      const new_nhph_firstIndex = $(".walmart_nav_linkk").index(new_nhph_firstNavLink);
      const new_nhph_firstPanel = $(".walmart_navmainn").eq(new_nhph_firstIndex);

      new_nhph_firstNavLink.addClass("active");
      new_nhph_firstNavLink.closest(".get_s_navflexmainsublim").addClass("active");
      new_nhph_firstPanel.slideDown(300);
      $(".hedcustom-overlay").fadeIn();
    } else {
      $(".walmart_navmainn").slideUp(200, function () {
        new_nhph_checkHeaderState();
      });
      $(".walmart_nav_linkk").removeClass("active");
      $(".get_s_navflexmainsublim").removeClass("active");
      $(".hedcustom-overlay").fadeOut();
    }

    $(".nhph_navs_linksmobile").slideToggle(300, function () {
      new_nhph_checkHeaderState();
    });

    let new_nhph_icon = $(this).find("i");
    new_nhph_icon.toggleClass("fa-bars fa-xmark");
    $(this).toggleClass("active");
  });

  // ===== Overlay Click - Close All =====
  $(".hedcustom-overlay").on("click", closeAllMenus);

  // ===== Walmart Main Flex Col Click - Close All =====
  $(".walmart_mainflexcol").on("click", closeAllMenus);

  // ===== Close All Menus Function =====
  function closeAllMenus() {
    // Stop ongoing animations to prevent state overwrite
    $(".nhph_navs_linksmobile, .walmart_navmainn, .hedsearch_navmainn").stop(true, true);

    $(".hedsearch_navmainn").hide().removeClass("active");
    $(".walmart_navmainn").hide();
    $(".walmart_nav_linkk").removeClass("active");
    $(".cust-search-iconmain").removeClass("active");
    $(".mobile_menu_bar i").removeClass("fa-xmark").addClass("fa-bars");
    $(".mobile_menu_bar").removeClass("active");
    $(".nhph_navs_linksmobile").hide();
    $(".hedcustom-overlay").fadeOut();
    $(".get_s_navflexmainsublim").removeClass("active");
    $(".nhph_headertopdatamain").hide();
    $("header").removeClass("active");
    $("body").css("overflow-y", "auto");
  }

  // ===== Header State Checker =====
  function new_nhph_checkHeaderState() {
    const new_nhph_isSearch = $(".hedsearch_navmainn").is(":visible");
    const new_nhph_isMenu = $(".nhph_navs_linksmobile").is(":visible");
    const new_nhph_isDropdown = $(".walmart_navmainn:visible").length > 0;
    const new_nhph_isActive = new_nhph_isSearch || new_nhph_isMenu || new_nhph_isDropdown;

    if (new_nhph_isActive) {
      $("header").addClass("active");
      $("body").css("overflow-y", "hidden");
    } else {
      $("header").removeClass("active");
      $("body").css("overflow-y", "auto");
    }

    // ✅ DESKTOP ONLY — Hide overlay if nothing is open
    if (window.innerWidth >= 992 && !new_nhph_isActive) {
      $(".hedcustom-overlay").fadeOut();
    }
  }
});


//   let cshed_lastScrollTop = 0;
//   const cshed_scrollTrigger = 100;

//   window.addEventListener('scroll', function () {
//     const cshed_scrollTop = window.pageYOffset || document.documentElement.scrollTop;
//     const cshed_header = document.querySelector('header');

//     if (cshed_scrollTop > cshed_scrollTrigger && cshed_scrollTop > cshed_lastScrollTop) {
//       // Scrolling down
//       cshed_header.classList.add('scrolled');
//     } else if (cshed_scrollTop < cshed_lastScrollTop && cshed_scrollTop <= cshed_scrollTrigger) {
//       // Scrolling up and reached the top again
//       cshed_header.classList.remove('scrolled');
//     }

//     cshed_lastScrollTop = cshed_scrollTop;
//   });

//        document.addEventListener("DOMContentLoaded", function () {
//     const tabButtons = document.querySelectorAll(".get_s_nav_tab-btn");
//     const tabContents = document.querySelectorAll(".get_s_nav_content");

//     if (tabButtons.length && tabContents.length) {
//       tabButtons.forEach(btn => btn.classList.remove("active"));
//       tabContents.forEach(content => content.classList.remove("active"));

//       tabButtons[0].classList.add("active");
//       tabContents[0].classList.add("active");
//     }

//     tabButtons.forEach((button, index) => {
//       button.addEventListener("click", function () {
//         tabButtons.forEach(btn => btn.classList.remove("active"));
//         tabContents.forEach(content => content.classList.remove("active"));

//         button.classList.add("active");
//         if (tabContents[index]) {
//           tabContents[index].classList.add("active");
//         }
//       });
//     });
//   });

//     document.addEventListener("DOMContentLoaded", function () {
//     const tabButtonsm = document.querySelectorAll(".get_s_nav_tab-btnn");
//     const tabContentsm = document.querySelectorAll(".get_s_nav_contentt");

//     if (tabButtonsm.length && tabContentsm.length) {
//       tabButtonsm.forEach(btn => btn.classList.remove("active"));
//       tabContentsm.forEach(content => content.classList.remove("active"));

//       tabButtonsm[0].classList.add("active");
//       tabContentsm[0].classList.add("active");
//     }

//     tabButtonsm.forEach((button, index) => {
//       button.addEventListener("click", function () {
//         tabButtonsm.forEach(btn => btn.classList.remove("active"));
//         tabContentsm.forEach(content => content.classList.remove("active"));

//         button.classList.add("active");
//         if (tabContentsm[index]) {
//           tabContentsm[index].classList.add("active");
//         }
//       });
//     });
//   });

// function adjustFaqHeight() {
//   const faqContainer = document.querySelector('.fq_nav_mainflexrightcolbotdivleft');
//   const videoDiv = document.querySelector('.fq_nav_mainflexrightcolbotdivrightflextop');
//   const flexBotDiv = document.querySelector('.fq_nav_mainflexrightcolbotdivrightflexbot');
//   const faqsQas = document.querySelectorAll('.fq_nav_mainflexrightbotdivleftfaqsflexdesc');

//   if (faqContainer && videoDiv && flexBotDiv) {
//     // Apply transition once
//     videoDiv.style.transition = "height 0.3s ease";
//     flexBotDiv.style.transition = "height 0.3s ease";

//     const faqContainerHeight = faqContainer.offsetHeight;

//     let isAnyFaqOpen = false;

//     faqsQas.forEach((faq) => {
//       const style = window.getComputedStyle(faq);
//       if (style.display !== 'none' && style.height !== '0px') {
//         isAnyFaqOpen = true;
//       }
//     });

//     const adjustedHeight = (faqContainerHeight - 8) / 2;

//     if (isAnyFaqOpen && faqContainerHeight > 0) {
//       videoDiv.style.height = `${adjustedHeight}px`;
//       flexBotDiv.style.height = `${adjustedHeight}px`;
//     } else {
//       faqContainer.style.height = 'fit-content';
//       videoDiv.style.height = `${adjustedHeight}px`;
//       flexBotDiv.style.height = `${adjustedHeight}px`;
//     }
//   }
// }

// // Auto-update every 500ms
// setInterval(adjustFaqHeight, 500);
